import React, { useContext } from 'react';
import { PropTypes } from 'prop-types';
import { makeStyles, TableCell } from '@material-ui/core';
import classnames from 'classnames';
import ListTableVariantContext from '../../../ListTableVariantContext';
import { getRowHeaderProps } from './TableCell';

const useStyles = makeStyles(theme => ({
  tableCellFixed: {
    position: 'sticky',
    left: '0px',
    bottom: '0px',
    zIndex: 1
  },
  tableCellLeftOfFixed: {}
}));

const TableFooterCell = ({
  className,
  fixed,
  leftOfFixed,
  children,
  isRowHeader,
  ...rest
}) => {
  const classes = useStyles();

  const variant = useContext(ListTableVariantContext);

  const Component = variant === 'table' ? TableCell : 'div';
  const rowHeaderProps = getRowHeaderProps({ variant, isRowHeader });

  return (
    <Component
      className={classnames(
        fixed ? classes.tableCellFixed : undefined,
        leftOfFixed ? classes.tableCellLeftOfFixed : undefined,
        className
      )}
      {...rowHeaderProps}
      {...rest}
    >
      {children}
    </Component>
  );
};

TableFooterCell.propTypes = {
  className: PropTypes.string,
  fixed: PropTypes.bool,
  leftOfFixed: PropTypes.bool,
  children: PropTypes.any,
  isRowHeader: PropTypes.bool
};

export default TableFooterCell;
